<template>
	<div>
		<nuxt-picture
			v-if="brand.logo"
			preload
			:src="brand?.logo"
			:alt="brand?.title"
			width="128"
			sizes="xs:96px sm:96px md:96px lg:128px xl:128px 2xl:128px"
			class="max-w-24 lg:max-w-32"
			:img-attrs="{
				class: 'object-contain object-left w-full h-full max-h-20',
			}"
		/>
	</div>
</template>

<script setup lang="ts">
export type ProductBrandData = {
	logo?: string;
	title?: string;
};

defineProps<{
	brand: ProductBrandData;
}>();
</script>
